var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","flat":"","outline":"","color":"pipefishOrange"},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v("Edit")])}
var staticRenderFns = []

export { render, staticRenderFns }